import { CircularProgress } from "@mui/material";

export default function DirectDepositSetupContent({ onSetupClick, isSetupLoading = false }) {
  return (
    <>
      <div className="dd-hero">
        <svg className="dd-hero-icon" width="48" height="48" viewBox="0 0 640 640" fill="none">
          <path
            d="M224 128C224 75 267 32 320 32C373 32 416 75 416 128C416 181 373 224 320 224C267 224 224 181 224 128zM72 350.5C72 277.6 119 217.3 186.9 183C193.1 198 201.8 211.7 212.4 223.6C155.5 251.3 120 299.8 120 350.5C120 396.3 147.8 437.8 195.9 465.1C203.4 469.4 208 477.3 208 486L208 520C208 524.4 211.6 528 216 528L246.1 528C249 528 251.7 526.4 253.1 523.8L262.5 506.4C267.2 497.7 276.7 492.8 286.5 494C297.4 495.3 308.6 496 320.1 496C331.6 496 342.8 495.3 353.7 494C363.5 492.8 373 497.8 377.7 506.4L387.1 523.8C388.5 526.4 391.2 528 394.1 528L424.2 528C428.6 528 432.2 524.4 432.2 520L432.2 486C432.2 477.4 436.8 469.4 444.3 465.1C457.9 457.4 469.9 448.5 480.1 438.6C484.6 434.3 490.5 431.9 496.7 431.9L560.1 431.9L560.1 335.9L538.6 335.9C527.9 335.9 518.5 328.8 515.5 318.6C512.5 308.4 508.2 298.5 502.5 289C499 283.1 498.1 276 500.2 269.5L519.4 208L512 208C493.8 208 477.3 214.7 464.6 225.8C457 232.4 446.1 233.6 437.3 228.8C434.1 227.1 430.9 225.4 427.6 223.8C440.5 209.4 450.5 192.3 456.7 173.5C473.3 164.9 492.1 160 512 160L530.2 160C557.2 160 576.4 186.2 568.4 211.9L549 274C551.4 278.6 553.5 283.2 555.5 288L560 288C586.5 288 608 309.5 608 336L608 432C608 458.5 586.5 480 560 480L505.9 480C497.9 487 489.2 493.6 480 499.5L480 520C480 550.9 454.9 576 424 576L393.9 576C373.3 576 354.4 564.7 344.6 546.6L342.8 543.2C327.8 544.2 312.1 544.2 297.1 543.2L295.3 546.6C285.5 564.7 266.6 576 246 576L216 576C185.1 576 160 550.9 160 520L160 499.5C107.6 465.5 72 413.1 72 350.5zM456 336C469.3 336 480 346.7 480 360C480 373.3 469.3 384 456 384C442.7 384 432 373.3 432 360C432 346.7 442.7 336 456 336zM248 256L392 256C405.3 256 416 266.7 416 280C416 293.3 405.3 304 392 304L248 304C234.7 304 224 293.3 224 280C224 266.7 234.7 256 248 256z"
            fill="#54FF99"
          />
        </svg>
        <div className="dd-hero-text">
          <h2 className="dd-title">Get paid, faster.</h2>
          <p className="dd-subtitle">
            Keep your Stake account funded automatically — so it&apos;s always ready when you are.
          </p>
        </div>
      </div>

      <div className="dd-steps">
        <div className="dd-step-card">
          <div className="dd-step-badge">1</div>
          <div className="dd-step-content">
            <div className="dd-step-title">Link your paycheck</div>
            <div className="dd-step-desc">Connect your employer in seconds</div>
          </div>
        </div>
        <div className="dd-step-card">
          <div className="dd-step-badge">2</div>
          <div className="dd-step-content">
            <div className="dd-step-title">Funds arrive automatically</div>
            <div className="dd-step-desc">No more manual transfers or waiting</div>
          </div>
        </div>
        <div className="dd-step-card">
          <div className="dd-step-badge">3</div>
          <div className="dd-step-content">
            <div className="dd-step-title">Get paid early</div>
            <div className="dd-step-desc">Up to 2 days before payday</div>
          </div>
        </div>
      </div>

      <div className="dd-cta-section">
        <button type="button" className="dd-cta-button" onClick={onSetupClick} disabled={isSetupLoading}>
          {isSetupLoading ? <CircularProgress size={20} /> : "Set up in 2 minutes"}
        </button>
        <div className="dd-trust-strip">
          <span className="dd-trust-dot">·</span>
          <svg width="14" height="14" viewBox="0 0 18 18" fill="none">
            <rect
              x="3"
              y="8"
              width="12"
              height="8"
              rx="1.5"
              fill="rgba(84,255,153,0.15)"
              stroke="#54FF99"
              strokeWidth="1.2"
            />
            <path
              d="M6 8V5.5C6 3.84 7.34 2.5 9 2.5C10.66 2.5 12 3.84 12 5.5V8"
              stroke="#54FF99"
              strokeWidth="1.2"
              strokeLinecap="round"
            />
            <circle cx="9" cy="12" r="1" fill="#54FF99" />
          </svg>
          <span className="dd-trust-text">256-bit encryption</span>
          <span className="dd-trust-dot">·</span>
          <svg width="14" height="14" viewBox="0 0 18 18" fill="none">
            <path
              d="M9 1.5L3 4.5V8.25C3 12.35 5.56 16.17 9 17.25C12.44 16.17 15 12.35 15 8.25V4.5L9 1.5Z"
              fill="rgba(84,255,153,0.15)"
              stroke="#54FF99"
              strokeWidth="1.2"
              strokeLinejoin="round"
            />
            <path
              d="M6.5 9L8 10.5L11.5 7"
              stroke="#54FF99"
              strokeWidth="1.3"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          <span className="dd-trust-text">Powered by Pinwheel</span>
        </div>
      </div>
    </>
  );
}
